
import * as fromRegUsr from '../../actions/login/reguser.actions';

export interface RegUserState {
  isRegistred: boolean;
  TokenActive: any | null;
  errorMessage: string | null;
}

export const initialState: RegUserState = {
    isRegistred: false,
    TokenActive: null,
    errorMessage: null
  };

export function RegUsrReducer(state = initialState, action: fromRegUsr.RegUsrAcciones): RegUserState {
    switch (action.type) {
      case fromRegUsr.RegUsrActionTypes.REGISTRO_SUCCESS: {
        return {
          ...state,
          isRegistred: true,
          TokenActive: {...action.TokenActivo},
          errorMessage: null
        };
      }
      case fromRegUsr.RegUsrActionTypes.REGISTRO_FAILURE: {
        return {
          ...state,
          isRegistred: false,
          TokenActive: null,
          errorMessage: {...action.payload.error}
        };
      }
      default: {
        return state;
      }
    }
  }